module.exports = {"360323101":"芦溪镇","360323102":"宣风镇","360323103":"上埠镇","360323104":"南坑镇","360323105":"银河镇","360323200":"源南乡","360323201":"长丰乡","360323202":"张佳坊乡","360323203":"新泉乡","360323204":"万龙山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360323.json
// module id = 1166
// module chunks = 0